import { useState } from "react";
import Head from "next/head";
import Image from "next/image";
import useUser from "../../lib/useUser";
import { Layout } from "../../common/Layout";
import { Imgix, Hero, Section } from "../../common/UI";
import withSession from "../../lib/session";
import {
  Container,
  Paper,
  Grid,
  Button,
  Box,
  Typography,
  Divider,
  Link,
  TextField,
  TextareaAutosize,
} from "@mui/material";
import { DatePicker } from "@mui/lab";
import { useTheme } from "@mui/material/styles";
import { useForm, Controller } from "react-hook-form";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import { request, gql } from "graphql-request";
import moment from "moment";

export default function RentalsSignup() {
  const [state, setState] = useState("ready");

  const {
    register,
    control,
    handleSubmit,
    formState: { errors: formErrors, isDirty, isSubmitting },
    setError,
    watch,
  } = useForm({
    defaultValues: {
      date: moment().format("YYYY-MM-DD"),
    },
  });

  const [openDatePicker, setOpenDatePicker] = useState(false);

  // const router = useHistory();
  // const addCreditCard = useAccountStripeCustomerMutate();
  const stripe = useStripe();
  const elements = useElements();

  const onSubmit = async (body) => {
    console.log("Submitting form", body);

    if (!stripe || !elements) {
      // Stripe.js has not yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      console.log("stripe not loaded");
      alert(
        "Sorry, we had a problem with our card processor. Please contact us to finish signup."
      );
      return;
    }

    setState("saving");

    console.log("elements:", elements);

    // alert('after payment');

    // get token for card (to apply to customer)
    const { token, error } = await stripe.createToken(
      // @ts-ignore
      elements.getElement(CardElement)
    );
    console.log("token:", token);
    if (error) {
      console.error("card error:", error);
      alert(
        "Sorry, there was a problem with your card, please check details and try again"
      );
      setState("ready");
      return;
    }

    // console.log("next...");

    const data = {
      name: body.name,
      email: body.email,
      phone: body.phone,
      notes: body.notes,
      date: body.date,
      stripeToken: token,
    };

    // console.log("Data:", data);

    try {
      const setupResp = await request(
        `/api/graphql`,
        gql`
          mutation rentalSetup($data: JSON) {
            rentalSetup(data: $data) {
              success
              message
              data
              error
            }
          }
        `,
        {
          data,
        }
      );

      console.log("setupResp:", setupResp);

      // Failed?
      if (!setupResp?.rentalSetup?.success) {
        setState("ready");
        if (setupResp?.rentalSetup?.error?.card == "failed") {
          alert(
            "Sorry, there was a problem with that card. Please check your card details and try agin. "
          );
        } else {
          alert(
            "Sorry, there was a problem saving your signup. Please try again or contact us via phone!"
          );
        }
        // dispatch({
        //   type: "MERGE",
        //   payload: {
        //     saving: null,
        //   },
        // });
        return;
      }

      // success!
      setState("complete");

      // // Redirect to viewing the lesson
      // const { id, rand } = lessonResp.lessonBook.data;
      // window.location.href = `/book/v/${rand}`;
      // return; // dont dispatch the "saving" update!
    } catch (err) {
      console.error("ERR:", err);
      alert(
        "Sorry, we encountered an error. Please check the details of your signup and try again. Please contact us by phone if you continue to have issues!"
      );
    }
  };

  const theme = useTheme();

  return (
    <Layout>
      <Grid item zeroMinWidth>
        <Hero minHeight={150}>
          <Box sx={{}}>
            <Typography
              variant="h2"
              sx={{
                textShadow: "0 1px 0 black",
                textAlign: "center",
              }}
            >
              Rent our Equipment
            </Typography>
          </Box>
          <Box sx={{}}>
            <Typography
              variant="h5"
              sx={{
                // textShadow: "0 1px 0 black",
                textAlign: "center",
              }}
            >
              High-quality boards, wetsuits, and more
            </Typography>
          </Box>
        </Hero>

        {/* <Container sx={{ minWidth: 0, overflowX: "auto", width: "100%" }}> */}
        <Container>
          {state === "complete" ? (
            <Box
              sx={{
                width: { md: 600 },
                margin: "0pt auto",
              }}
            >
              <Paper variant="outlined" sx={{ p: 3 }}>
                <Typography variant="h6" paragraph sx={{ fontWeight: "bold" }}>
                  Signup Complete
                </Typography>
                <Typography variant="body1">
                  We'll contact you shorty with more information!
                </Typography>
              </Paper>
            </Box>
          ) : (
            <Box
              sx={{
                width: { md: 600 },
                margin: "0pt auto",
              }}
            >
              <Paper variant="outlined" sx={{ p: 3 }}>
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <Controller
                      name="date"
                      control={control}
                      // defaultValue=""
                      rules={{ required: true }}
                      render={({ field, fieldState }) => (
                        <DatePicker
                          {...field}
                          open={openDatePicker}
                          onClose={() => setOpenDatePicker(false)}
                          label="Date of Rental"
                          onChange={(val) =>
                            field.onChange(val.format("YYYY-MM-DD"))
                          }
                          renderInput={(params) => (
                            <TextField
                              fullWidth
                              size="small"
                              margin="dense"
                              {...params}
                              onClick={() => setOpenDatePicker(true)}
                              error={fieldState.invalid ? true : false}
                            />
                          )}
                          inputFormat={"dddd, MMMM Do YYYY"}
                          // mask={"dddd, MMMM Do YYYY"}
                          mask={null}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Controller
                      name="name"
                      control={control}
                      defaultValue=""
                      rules={{ required: true }}
                      render={({ field, fieldState }) => (
                        <TextField
                          {...field}
                          label="Name"
                          size="small"
                          margin="dense"
                          fullWidth
                          error={fieldState.invalid ? true : false}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Controller
                      name="email"
                      control={control}
                      defaultValue=""
                      rules={{ required: true }}
                      render={({ field, fieldState }) => (
                        <TextField
                          {...field}
                          type="email"
                          label="Email"
                          size="small"
                          margin="dense"
                          fullWidth
                          error={fieldState.invalid ? true : false}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Controller
                      name="phone"
                      control={control}
                      defaultValue=""
                      rules={{ required: true }}
                      render={({ field, fieldState }) => (
                        <TextField
                          {...field}
                          type="tel"
                          label="Phone Number"
                          size="small"
                          margin="dense"
                          fullWidth
                          error={fieldState.invalid ? true : false}
                        />
                      )}
                    />
                  </Grid>
                </Grid>
                <br />

                <CardElement />
                <br />

                <Controller
                  name="notes"
                  control={control}
                  defaultValue=""
                  // rules={{ required: true }}
                  render={({ field, fieldState }) => (
                    <TextareaAutosize
                      {...field}
                      placeholder="Rental needs"
                      fullWidth
                      minRows={2}
                      error={fieldState.error ? true : false}
                      style={{
                        width: "100%",
                        padding: "8px 14px",
                        fontFamily: theme.typography.fontFamily,
                        fontSize: "1rem",
                        lineHeight: "1.1rem",
                        border: fieldState.error
                          ? "1px solid red"
                          : "1px solid #ccc",
                        borderRadius: 4,
                      }}
                    />
                    // <TextField
                    //   {...field}
                    //   label="Additional Notes (optional)"
                    //   size="small"
                    //   margin="dense"
                    //   fullWidth
                    //   error={fieldState.invalid ? true : false}
                    //   // helperText="Add any additional notes for your rental or signup"
                    // />
                  )}
                />
                <br />
                <br />
                <Divider />
                <br />
                <Button
                  variant="contained"
                  color="success"
                  disabled={!isDirty || state === "saving"}
                  fullWidth
                  onClick={handleSubmit(onSubmit)}
                >
                  {state === "saving" ? "Please wait..." : "Complete Signup"}
                </Button>
                <br />
                <br />
                <Typography variant="body2" sx={{ textAlign: "center" }}>
                  We will follow-up with you shortly after completing signup!
                </Typography>
              </Paper>
              <br />
              <Box sx={{ textAlign: "center" }}>
                <a href="https://stripe.com" target="_blank">
                  <Image src="/stripe.svg" height="34" width="124" />
                </a>
              </Box>
            </Box>
          )}
        </Container>
        <br />
      </Grid>
    </Layout>
  );
}

export const getServerSideProps = withSession(async function ({ req, res }) {
  const user = req.session.get("user") ?? null;
  return {
    props: { user },
  };
});
